import { InputType } from '@/types';
import type { IInput } from '@/types';
import isBlobUrl from '@/utils/file/isBlobUrl';
import isDataUrl from '@/utils/file/isDataUrl';

/**
 * The Generate button gate: every input must be populated with usable data
 * — non-empty text or a CDN-hosted media URL that's finished uploading.
 * Local previews (`blob:` from device uploads, `data:` base64 from canvas)
 * are rejected so a temporary preview can never be submitted to the webhook.
 */
const isFormValid = (inputs: IInput[]): boolean =>
  inputs.every((input) => {
    if (input.type === InputType.TEXT) {
      return (input.value ?? '').trim().length > 0;
    }
    return (
      Boolean(input.src) &&
      !isBlobUrl(input.src) &&
      !isDataUrl(input.src) &&
      !input.isLoading
    );
  });

export default isFormValid;
